export const sideBarText = '#a2a3b7';
export const sideBarIcon = '#494b74';
export const successButton = '#58B368';
export const successHover = '#3F9A4F';
export const successA = '#58B368';
